import { RECAPTCHA_SITE_KEY } from "app/constants/variables";
import { useCallback, useState } from "react";

export function useGetToken() {
  const [loading, setLoading] = useState(false);

  const getToken = useCallback(() => {
    let grecaptcha = window.grecaptcha;

    if (typeof grecaptcha === "undefined") {
      grecaptcha = {} as ReCaptchaV2.ReCaptcha & {
        enterprise: ReCaptchaV2.ReCaptcha;
      };
    }

    grecaptcha.ready = function (cb: VoidFunction) {
      if (typeof grecaptcha === "undefined") {
        // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
        // configuration. By default, any functions listed in its 'fns' property
        // are automatically executed when reCAPTCHA loads.
        const c = "___grecaptcha_cfg";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any)[c] = (window as any)[c] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((window as any)[c]["fns"] = (window as any)[c]["fns"] || []).push(cb);
      } else {
        cb();
      }
    };

    return new Promise<string>((resolve, reject) => {
      setLoading(true);
      grecaptcha.ready(function () {
        grecaptcha
          .execute(RECAPTCHA_SITE_KEY || "", { action: "submit" })
          .then(
            (token: string) => {
              setLoading(false);
              resolve(token);
            },
            (reason) => {
              setLoading(false);
              reject(reason);
            }
          );
      });
    });
  }, []);

  return { getToken, loading };
}
